import React from "react";
import { useNavigate } from "react-router-dom";

import "../proceed-card/proceed-card.css";
import "./styles.css";

import { replaceImageUrlSize } from "../../utils/image";
import LikeProperty from "../global/like-property";
import StarRating from "../global/star-rating/StarRating";

import noImage from "../../assets/image_not_supported.svg";
import ButtonLink from "../global/button/ButtonLink";
import UserInputViewer from "../global/UserInputViewer";
import GlobalImage from "../global/image/image";
import ReadMoreContent from "../global/read-more-content";
import toggleClass from "../../utils/dom/toggle-class.util";
import AiReviewToolTip from "../global/ai-review-tooltip";

const SuggestedPropertyCard = ({ property = {} }) => {
  const navigate = useNavigate();

  const navigateURL = `/property/${property?.id}/${property?.name}`;

  function handleMobileNavigate(e) {
    // return if element with this class is clicked ".property-card-left .like"
    const isLikeClicked = e.target.closest("#like-property");
    const showMoreButton = e.target.closest(".read-more-content-btn");

    if (isLikeClicked || showMoreButton) {
      return;
    }

    if (window.innerWidth < 768) {
      navigate(navigateURL);
    }
  }
  const aiOverallScore = property?.aiReviewSummary?.overallScore;
  const showAiReviews = aiOverallScore > 0;

  function getScoreName(score) {
    if (score >= 9.6 && score <= 10) return "Outstanding";
    if (score >= 8.6 && score <= 9.5) return "Superb";
    if (score >= 7.6 && score <= 8.5) return "Very Good";
    if (score >= 6.6 && score <= 7.5) return "Good";
    if (score >= 5.6 && score <= 6.5) return "Pleasant";
    if (score >= 4.6 && score <= 5.5) return "Flexible";
    if (score >= 3.6 && score <= 4.5) return "Disappointing";
    if (score >= 2.6 && score <= 3.5) return "Poor";
    if (score >= 1.6 && score <= 2.5) return "Very poor";
    return "Bad";
  }

  return (
    <div>
      <div className="suggested-listing-card-title">
        <span className="suggested-listing-card-title-text">Upcoming</span>
      </div>
      <div className="property-card suggested-listing-card  box-border">
        <div className="property-image">
          {property?.defaultImage ? (
            <picture>
              <source
                media="(max-width: 768px)"
                srcSet={replaceImageUrlSize(property?.defaultImage, "medium")}
                alt="Building"
                className="building skeleton-loading"
              />
              <GlobalImage src={replaceImageUrlSize(property?.defaultImage, "thumbnail")} alt="Building" className="building " loading="lazy" />
            </picture>
          ) : (
            <img
              src={noImage}
              alt="Not Available"
              className="building"
              onLoad={(e) => {
                toggleClass(e.target, "skeleton-loading", false);
              }}
            />
          )}
        </div>
        {showAiReviews && (
          <div className="dest-listing-card-mobile__ai-review">
            <div className="average-ai-rating-info average-ai-rating-info">
              <span className="dest-listing-card__ai-review-label ">Average AI Rating</span>
              <AiReviewToolTip />
            </div>
            <div className="dest-listing-card-mobile__ai-review-wrapper">
              <span className="dest-listing-card__ai-review-score">{Math.floor(aiOverallScore * 10) / 10}</span>
              <span className="dest-listing-card__ai-review-desc">{getScoreName((Math.floor(aiOverallScore * 10) / 10) * 2)}</span>
            </div>
          </div>
        )}
        <div className="property-card-info">
          <div className="property-info">
            <div className="prop-data">
              <h3>
                <UserInputViewer tag="Link" text={property?.name} />
              </h3>
              <UserInputViewer tag="address" text={property?.address} />

              <StarRating rating={property?.rating} />
            </div>
            {showAiReviews && (
              <div className="dest-listing-card__ai-review">
                <div className="dest-listing-card__ai-review-wrapper">
                  <div className="average-ai-rating-info">
                    <span className="dest-listing-card__ai-review-label">Average AI Rating</span>
                    <AiReviewToolTip />
                  </div>
                  <span className="dest-listing-card__ai-review-desc">{getScoreName((Math.floor(aiOverallScore * 10) / 10) * 2)}</span>
                </div>
                <span className="dest-listing-card__ai-review-score">{Math.floor(aiOverallScore * 10) / 10}</span>
              </div>
            )}
          </div>
          {/* <UserInputViewer
          tag="p"
          className="suggested-listing-card-description"
          text={displayedDescriptionWord}
        /> */}

          <ReadMoreContent content={property?.description} fontSize="16px" />

          {/* <ButtonLink
            to={navigateURL}
            size="sm"
            className="suggested-listing-card-btn"
          >
            View Details
          </ButtonLink> */}
        </div>
      </div>
    </div>
  );
};

export default SuggestedPropertyCard;
